import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const useCancelOrder = ({ onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: async (data: { orderId: string; note: AddNoteRequest }) => {
      await OrdersClient.cancel({
        orderId: data.orderId,
        note: data.note,
      });
    },
    onSuccess,
    onError,
  });

  return {
    cancel: mutate,
  };
};
